import React from "react";
import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'

const analytics = Analytics({
    app: 'hocon-react',
    plugins: [
      googleAnalytics({
        trackingId: 'UA-17832528-5'
      })
    ]
  })
const GoogleAnalytics = () => {
    analytics.page();
    return (
        <React.Fragment>
        </React.Fragment>
    );
}

export default GoogleAnalytics;